export const TOKENIZED_ACTIONS_MODAL_SHOW = "TOKENIZED_ACTIONS_MODAL_SHOW";
export const TOKENIZED_ACTIONS_MODAL_HIDE = "TOKENIZED_ACTIONS_MODAL_HIDE";
export const TX_REDEEM_SHARES_MODAL_SHOW = "TX_REDEEM_SHARES_MODAL_SHOW";
export const TX_REDEEM_SHARES_MODAL_HIDE = "TX_REDEEM_SHARES_MODAL_HIDE";
export const SET_REDEEM_TX_VALIDATOR = "SET_REDEEM_TX_VALIDATOR";
export const TX_REDEEM_SHARES_MEMO_SET = "TX_REDEEM_SHARES_MEMO_SET";
